import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import CalendarHeatmap from 'react-calendar-heatmap';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import 'react-calendar-heatmap/dist/styles.css';
import './heatmap-style.css'


const Divider = () => (
  <div className="border-b border-pink-200 mt-2 mb-3"></div>
)

function Details(props) {
  let params = useParams();
  let songId = params.songId
  const [loading, setLoading] = useState(true)
  const [fetching, setFetching] = useState(true)
  const [found, setFound] = useState(true)
  const [songTitle, setSongTitle] = useState("")
  const [songArtist, setSongArtist] = useState("")
  const [heatmapStart, setHeatmapStart] = useState("")
  const [heatmapEnd, setHeatmapEnd] = useState("")
  const [heatmapData, setHeatmapData] = useState([])
  const [isDateSelected, setIsDateSelected] = useState(false)
  const [selectedDate, setSelectedDate] = useState("")
  const [loadingDateDetails, setLoadingDateDetails] = useState(false)
  const [plays, setPlays] = useState([])
  const [songLinksAvailable, setSongLinksAvailable] = useState(false)
  const [songLinks, setSongLinks] = useState({
    "apple" : "",
    "spotify" : "",
    "youtube" : "",
    "ytmusic" : ""
  })

  const refreshDetails = (t) => {
    setFetching(true)
    fetch('https://api.durianbit.com/k92/details/' + t)
      .then(response => response.json())
      .then(json => {
        // console.log(json)
        if (json.status == -1) {
          setFound(false)
        } else {
          setHeatmapStart(json.startDate)
          setHeatmapEnd(json.endDate)
          setSongLinksAvailable(json.songLinksAvailable)
          setSongLinks(json.songLinks)
          setHeatmapData(json.heatmap)
          setSongTitle(json.song)
          setSongArtist(json.artist)
        }
        setLoading(false)
        setFetching(false)
      })
  }

  const refreshDateDetails = (t) => {
    setLoadingDateDetails(true)
    fetch('https://api.durianbit.com/k92/plays/' + songId + "/" + t)
      .then(response => response.json())
      .then(json => {
        // console.log(json)
        setPlays(json.plays)
        setLoadingDateDetails(false)
      })
    }


  useEffect(() => {
    refreshDetails(songId)
  }, [loading])
  return (
    <>
    <div className="flex flex-col text-left font-sans text-pink-400">
      <Link to="/" className="text-sm mb-3">
        {"<< Back"}
      </Link>
      <h4 className="text-2xl md:text-3xl font-bold">{ loading ? "Loading.." : (found ? songTitle : "Song Not Found")}</h4>
    </div>
    
    <div className="flex flex-col text-left font-sans text-pink-400">
      {
          found &&
          <>
          <p className="text-xl md:text-2xl font-sans">{songArtist}</p>
          </>
      }
    </div>

    <ReactTooltip />
    { found && 
    <div className="mt-5">
      <CalendarHeatmap
        data-tip='hello'
        startDate={new Date(heatmapStart)}
        endDate={new Date(heatmapEnd)}
        values={heatmapData}
        classForValue={(value) => {
          if (!value || value.count < 1) {
            return 'color-scale-1';
          } else if (value.count > 7) {
            return 'color-scale-9';
          } else {
            return `color-scale-${value.count+1}`;
          }
        }}
        tooltipDataAttrs={value => {
          if (value) {
            // convert value.date from YYYY-MM-DD to DD/MM/YYYY format
            const date = new Date(value.date);
            const dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
              return {
                  'data-tip': `${dateString} - ${value.count} play${value.count == 1 ? '' : 's'}`,
              }
          }
        }}
        onMouseOver={(value) => {
          ReactTooltip.show(value.target)
        }}
        onMouseLeave={(value) => {
          ReactTooltip.hide(value.target)
        }}
        onClick={(value) => {
          // convert value.date from YYYY-MM-DD to DD/MM/YYYY format
          const date = new Date(value.date);
          const dateString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
          setLoadingDateDetails(true)
          setIsDateSelected(true)
          refreshDateDetails(value.date)
          setSelectedDate(dateString)
        }}
      />

    </div>
    }
    {
      !loading && found && songLinksAvailable &&
      <div className="flex flex-col text-left font-sans text-pink-400 mt-4">
        <Divider />
        <div className='flex space-x-2 mt-2'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z" />
  </svg>
          <p className="text-xl md:text-2xl font-sans">
            Available for streaming on
          </p>
        </div>
        <div className="flex flex-col space-y-3 mt-4 sm:flex-row sm:space-y-0 sm:space-x-6 w-full">
          {
            songLinks.apple != "" &&
            <a href={songLinks.apple} target="_blank" className="">
              <button className="bg-pink-600 text-pink-100 hover:text-pink-300 text-xs lg:text-sm font-bold py-2 px-4 rounded-3xl hover:bg-pink-700 w-full">
                 Music
              </button>
            </a>
          }
          {
            songLinks.spotify != "" &&
            <a href={songLinks.spotify} target="_blank" className="">
              <button className="bg-pink-600 text-pink-100 hover:text-pink-300 text-xs lg:text-sm font-bold py-2 px-4 rounded-3xl hover:bg-pink-700 w-full">
                Spotify
              </button>
            </a>
          }
          {
            songLinks.youtube != "" &&
            <a href={songLinks.youtube} target="_blank" className="">
              <button className="bg-pink-600 text-pink-100 hover:text-pink-300 text-xs lg:text-sm font-bold py-2 px-4 rounded-3xl hover:bg-pink-700 w-full">
                YouTube
              </button>
            </a>
          }
          {
            songLinks.ytmusic != "" &&
            <a href={songLinks.ytmusic} target="_blank" className="">
              <button className="bg-pink-600 text-pink-100 hover:text-pink-300 text-xs lg:text-sm font-bold py-2 px-4 rounded-3xl hover:bg-pink-700 w-full">
                YouTube Music
              </button>
            </a>
          }
        </div>
      </div>
    }

    {
      isDateSelected && 
      <div className="flex flex-col text-left font-sans text-pink-400 mt-4">
        <Divider />
        <p className="text-xl md:text-2xl font-sans">Viewing plays on {selectedDate}</p>
        {
          loadingDateDetails ?
            <p className="text-sm font-bold font-sans mt-3">Loading...</p>
          :
            (plays.length == 0) ?
            <p className="text-sm font-bold font-sans mt-3">This song wasn't played on this date.</p>
            :
            <div className="flex flex-col">
              {/* <p className="text-sm font-bold font-sans mt-3">{plays.length} play{plays.length == 1 ? '' : 's'} found.</p> */}
              <div className="flex flex-col">
                {
                  plays.map((play, index) => {
                    const dateObj = moment(play.playedAt * 1000)
                    const timeString = dateObj.format('h:mm A')
                  
                    return (
                      <div className="flex flex-col mt-6" key={index}>
                        <p className="text-md font-bold font-sans">{timeString}</p>
                        <p className="text-sm font-sans">on {play.programme}</p>
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>
        }
      </div>
    }

    </>
  )
}

export default Details